import images from "./images";

const home = {
  image: images.home1,
  subtitle: "Welcome to AS Designs",
  title: "Premium React & HTML Templates for Modern Websites",
  content: "Discover high-quality, responsive website templates built for startups, businesses, and developers. Launch faster with clean, customizable, and conversion-focused designs.",
  buttonText: "Browse Templates",
  buttonLink: "Website-Templates",
}

export default home;